// extracted by mini-css-extract-plugin
module.exports = {"filters":"Filters_filters__3OQvy","filterBadge":"Filters_filterBadge__I7qgo","filterTextBadge":"Filters_filterTextBadge__PH31B"};